import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "fullscreen bg-blue text-white text-center q-pa-md flex flex-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("div", null, [
      _createElementVNode("div", { style: {"font-size":"30vh"} }, " 404 "),
      _createElementVNode("div", {
        class: "text-h2",
        style: {"opacity":".4"}
      }, " Oops. Nothing here... ")
    ], -1)
  ]))]))
}